import { type HTMLAttributes } from "react";
import { type CSSObject } from "@emotion/react";
import DownloadCSVButton, {
  DownloadCSVProps,
} from "@/reports/components/DownloadCSVButton";
import { headingCss, tableHeaderContainerCss } from "./TableTitle.styles";

type TableTitleProps = {
  /**
   * table's title. will render in an h3 tag
   */
  title: string;
  downloadCSVProps?: DownloadCSVProps | undefined;
} & { css?: CSSObject } & HTMLAttributes<HTMLHeadingElement>;

const TableTitle = (props: TableTitleProps) => {
  const { title, downloadCSVProps, ...passedFromAngelou } = props;

  return (
    <div css={tableHeaderContainerCss}>
      <h2 {...passedFromAngelou} css={[passedFromAngelou?.css, headingCss]}>
        {title}
      </h2>
      {downloadCSVProps ? <DownloadCSVButton {...downloadCSVProps} /> : null}
    </div>
  );
};

export default TableTitle;
